import script from "./HabitacionesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./HabitacionesForm.vue?vue&type=script&setup=true&lang=js"

import "./HabitacionesForm.vue?vue&type=style&index=0&id=4eb3a436&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb3a436"]])

export default __exports__